import { ServiceTypeEnum, ServiceTypeEnumIcon } from '@supoui/shared/model/enumerations/service-type.enum';

export class DropDownServiceOrderItemModel {
  serviceOrderId: string;
  serviceOrderType: string;
  serviceTypeName: string;
  disabled: boolean = false;
  providerName: string | null;
  isServiceOrder: boolean;

  public constructor(init?: Partial<DropDownServiceOrderItemModel>) {
    Object.assign(this, init);
  }

  iconFileName(): string {
    return '/content/icons/' + ServiceTypeEnumIcon.getIcon(ServiceTypeEnum[this.serviceOrderType]);
  }
}
